<template>
  <div :class="['automap-object', 'connect-info', lowerCase(objectType)]">
    <div class="connect-info-title title-popup content-between">
      <span>
        {{ activeContent === 'CONNECT_DEVICE' ? '연결장비' : '변경이력' }}
      </span>
      <el-switch
        v-model="activeContent"
        class="event-type-switch"
        size="small"
        inactive-text="연결장비"
        active-text="변경이력"
        inactive-value="CONNECT_DEVICE"
        active-value="CHANGE_HIST"
        inactive-color="#38608e"
        active-color="#38608e"
        v-if="!isLan"
      >
      </el-switch>
    </div>
    <w-connect-device-table ref="connectTable" v-show="activeContent === 'CONNECT_DEVICE'" :is-obj="isObj" :object-type="objectType" :object-info="objectInfo"/>
    <w-change-hist-table ref="histTable" v-show="activeContent === 'CHANGE_HIST'" :is-obj="isObj" :object-type="objectType"/>
  </div>
</template>

<script>
import { RELATIONSHIP_INFO } from '@/constants/topologymap-major-info';
import { isEmpty, lowerCase } from 'lodash';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import WChangeHistTable from '@/views/topologymap/components/major-info/components/ChangeHistTable';
import WConnectDeviceTable from '@/views/topologymap/components/major-info/components/ConnectDeviceTable';

export default {
  name: 'WAutomapObjectConnectInfoView',
  components: {
    WChangeHistTable,
    WConnectDeviceTable,
  },
  props: {
    objectInfo: {
      type: Object,
      default: () => {},
    },
    isObj: {
      type: Boolean,
      default: false,
    },
    objectType: {
      type: String,
      default: 'DEVICE',
    },
  },
  data() {
    return {
      getValueAfterCheckEmpty,
      isEmpty,
      lowerCase,
      /**
       * 구성정보 표현 객체
       * @type {Object}
       */
      RELATIONSHIP_INFO,
      connectDeviceData: [{
        connectInterfaceName: 'Gi1/0/1',
        deviceName: 'IDC_Test_SubSW',
        interfaceIp: '',
        interfaceMac: 'CC:46:D6:E9:5F:81',
      }],
      changeHistData: [],
      activeContent: 'CONNECT_DEVICE',
      isLan: false,
    };
  },
  computed: {
    /**
     * 관리대상 정보 객체
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    objInfo() {
      return {
        label: this.objectInfo.objName,
        obj: this.objectInfo,
      };
    },
    connectDeviceColums() {
      let columns = [{ prop: '', label: '', columnKey: '', scopedSlot: '' }];
      columns = RELATIONSHIP_INFO.CONNECT_DEVICE[this.objectType] || [];
      return columns;
    },
    changeHistColums() {
      let columns = [{ prop: '', label: '', columnKey: '', scopedSlot: '' }];
      columns = RELATIONSHIP_INFO.CHANGE_HIST[this.objectType] || [];
      return columns;
    },
    subInfo() {
      return ((idx) => (RELATIONSHIP_INFO.CONNECT_DEVICE_DETAIL[idx]));
    },
  },
  methods: {
    /**
      * 데이터 초기화(요청데이터)
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} configInfoData [description]
     */
    setData(connectDeviceData, changeHistData, isLan) {
      if (isLan) {
        this.isLan = isLan;
        this.activeContent = 'CHANGE_HIST';
      } else {
        this.$refs.connectTable.setData(connectDeviceData);
      }
      this.$refs.histTable.setData(changeHistData);
    },
    /**
     * 데이터 초기화(기본값)
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    initData() {
      this.configInfoData = {};
      this.activeTab = 'basic';
      if (this.$refs.collapse) {
        this.$refs.collapse.setActiveNames([]);
      }
    },
    /**
     * 포매터 속은 key값에 따른 값 변환 함수
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} value     [description]
     * @param  {[type]} key       [description]
     * @param  {[type]} formatter [description]
     * @param  {[type]} unit      [description]
     * @param  {[type]} unitText  [description]
     * @return {[type]}           [description]
     */
    convertValue(value, key, formatter, unit, unitText) {
      // formatter 처리
      if (formatter === 'value') {
        let result = '';
        if (isEmpty(unit) && isEmpty(unitText)) {
          result = `${convertValuByUnit(value, '', true, null, true)}`;
        } else {
          result = `${convertValuByUnit(value, unit, true, false, true)}${isEmpty(unitText) ? '' : unitText}`;
        }
        return result;
      } else if (formatter === 'label') {
        if (key === 'netinterfaceStatusOper' || key === 'netinterfaceStatusAdmin') {
          return (value === 1) ? 'UP' : 'DOWN';
        }
      }

      // key 값에 다른 값 변환 처리
      if (key === 'adminInfoLabel') {
        return `${getValueAfterCheckEmpty(this.configInfoData.objManagerIdMajor)} / ${getValueAfterCheckEmpty(this.configInfoData.objManagerIdMinor)}`;
      }
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>

<style lang="scss">
.automap-object.connect-info {
  .table-sub-list-info {
    th {
      width: 115px;
      vertical-align: top;
      color: #333;
      font-weight: 600;
      font-size: 11px;
      text-align: left;
      background-color: transparent;
      border-bottom: 0px !important;
    }
    td {
      color: #7d798c !important;
      border-bottom: 0px !important;
    }
  }
  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: transparent !important;
  }

  .el-table__expand-icon {
    height: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/major-info/AutomapObjectConnectInfoView.vue